import setQueryParamsToString from '../utils/setQueryParamsToString';
import { getHeaders } from './authentication';
import orderApi from '../apis/orders';

const GET_DASHBOARD_ORDERS_REQUEST = 'GET_DASHBOARD_ORDERS_REQUEST';
const GET_DASHBOARD_ORDERS_SUCCESS = 'GET_DASHBOARD_ORDERS_SUCCESS';
const GET_DASHBOARD_ORDERS_FAILURE = 'GET_DASHBOARD_ORDERS_FAILURE';
const GET_DASHBOARD_ORDERS_RESET = 'GET_DASHBOARD_ORDERS_RESET';

const GET_DASHBOARD_ORDERS_COUNTS_REQUEST = 'GET_DASHBOARD_ORDERS_COUNTS_REQUEST';
const GET_DASHBOARD_ORDERS_COUNTS_SUCCESS = 'GET_DASHBOARD_ORDERS_COUNTS_SUCCESS';
const GET_DASHBOARD_ORDERS_COUNTS_FAILURE = 'GET_DASHBOARD_ORDERS_COUNTS_FAILURE';

const GET_DASHBOARD_ORDERS_COUNTS_PER_PHARMACY_REQUEST = 'GET_DASHBOARD_ORDERS_COUNTS_PER_PHARMACY_REQUEST';
const GET_DASHBOARD_ORDERS_COUNTS_PER_PHARMACY_SUCCESS = 'GET_DASHBOARD_ORDERS_COUNTS_PER_PHARMACY_SUCCESS';
const GET_DASHBOARD_ORDERS_COUNTS_PER_PHARMACY_FAILURE = 'GET_DASHBOARD_ORDERS_COUNTS_PER_PHARMACY_FAILURE';

const GET_PHARMACIES_TO_ASSIGN_REQUEST = 'GET_PHARMACIES_TO_ASSIGN_REQUEST';
const GET_PHARMACIES_TO_ASSIGN_SUCCESS = 'GET_PHARMACIES_TO_ASSIGN_SUCCESS';
const GET_PHARMACIES_TO_ASSIGN_FAILURE = 'GET_PHARMACIES_TO_ASSIGN_FAILURE';

const initialState = {
  data: null,
  error: null,
  fetching: false,
  counts: null,
  fetchingCounts: false,
  ordersCountPerPharmacy: null,
  fetchingOrdersCountPerPharmacy: false,
  pharmacies: [],
  fetchingPharmacies: false,
  errorPharmacies: null,
};

export const getPharmaciesToAssign = ({ longitude, latitude, type = 'delivery', excluded_pharmacies }) => {
  return {
    types: [GET_PHARMACIES_TO_ASSIGN_REQUEST, GET_PHARMACIES_TO_ASSIGN_SUCCESS, GET_PHARMACIES_TO_ASSIGN_FAILURE],
    payload: {
      request: {
        url: '/pharmacies-public/search',
        method: 'POST',
        headers: getHeaders(),
        data: {
          coord_lat: latitude,
          coord_long: longitude,
          unit: 'mi',
          range: 12,
          excluded_pharmacies,
          ...(type === 'delivery'
            ? {
                local_or_postal_private_prescription_delivery: true,
              }
            : {
                delivery_options: {
                  collection: {
                    private_prescription: true,
                  },
                },
              }),
        },
      },
    },
  };
};

const _getDashboardOrders = (queryParams) => {
  return {
    types: [GET_DASHBOARD_ORDERS_REQUEST, GET_DASHBOARD_ORDERS_SUCCESS, GET_DASHBOARD_ORDERS_FAILURE],
    payload: {
      request: {
        url: '/orders/support/dashboard' + setQueryParamsToString(queryParams),
        method: 'GET',
        headers: getHeaders(),
      },
    },
  };
};

const _searchDashboardOrders = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_DASHBOARD_ORDERS_REQUEST });
      const { orderIds, pagination } = await orderApi.searchSupportOrder(payload);
      const { data } = await orderApi.enrichSupportOrders({ type: payload.type, order_ids: orderIds });
      dispatch({ type: GET_DASHBOARD_ORDERS_SUCCESS, payload: { data: { data, pagination } } });
    } catch (error) {
      dispatch({ type: GET_DASHBOARD_ORDERS_FAILURE, error });
    }
  };
};

export const getDashboardOrders = (query) => {
  if (query.search) {
    return _searchDashboardOrders(query);
  } else {
    return _getDashboardOrders(query);
  }
};

export const getDashboardOrdersReset = () => ({
  type: GET_DASHBOARD_ORDERS_RESET,
});

export const getDashboardOrdersCounts = (queryParams) => {
  return {
    types: [
      GET_DASHBOARD_ORDERS_COUNTS_REQUEST,
      GET_DASHBOARD_ORDERS_COUNTS_SUCCESS,
      GET_DASHBOARD_ORDERS_COUNTS_FAILURE,
    ],
    payload: {
      request: {
        url: '/orders/support/dashboard/counts' + setQueryParamsToString(queryParams),
        method: 'GET',
        headers: getHeaders(),
      },
    },
  };
};

const _searchDashboardOrderCountsPerPharmacy = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_DASHBOARD_ORDERS_COUNTS_PER_PHARMACY_REQUEST });
      const { orderIds } = await orderApi.searchSupportOrder(payload);

      dispatch({
        types: [
          GET_DASHBOARD_ORDERS_COUNTS_PER_PHARMACY_REQUEST,
          GET_DASHBOARD_ORDERS_COUNTS_PER_PHARMACY_SUCCESS,
          GET_DASHBOARD_ORDERS_COUNTS_PER_PHARMACY_FAILURE,
        ],
        payload: {
          request: {
            url: '/orders/support/dashboard/counts-by-pharmacy' + setQueryParamsToString({ ...payload }),
            method: 'POST',
            headers: getHeaders(),
            data: {
              order_ids: orderIds,
            },
          },
        },
      });
    } catch (error) {
      dispatch({ type: GET_DASHBOARD_ORDERS_FAILURE, error });
    }
  };
};

const _getDashboardOrdersCountsPerPharmacy = (queryParams) => {
  return {
    types: [
      GET_DASHBOARD_ORDERS_COUNTS_PER_PHARMACY_REQUEST,
      GET_DASHBOARD_ORDERS_COUNTS_PER_PHARMACY_SUCCESS,
      GET_DASHBOARD_ORDERS_COUNTS_PER_PHARMACY_FAILURE,
    ],
    payload: {
      request: {
        url: '/orders/support/dashboard/counts-by-pharmacy' + setQueryParamsToString(queryParams),
        method: 'POST',
        headers: getHeaders(),
      },
    },
  };
};

export const getDashboardOrdersCountsPerPharmacy = (queryParams) => {
  if (queryParams.search) {
    return _searchDashboardOrderCountsPerPharmacy(queryParams)
  } else {
    return _getDashboardOrdersCountsPerPharmacy(queryParams);
  }
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DASHBOARD_ORDERS_REQUEST:
      return { ...state, fetching: true };
    case GET_DASHBOARD_ORDERS_SUCCESS:
      return { ...state, fetching: false, data: action.payload.data };
    case GET_DASHBOARD_ORDERS_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.error?.response?.data?.error?.text || action.error.message,
      };
    case GET_DASHBOARD_ORDERS_RESET:
      return { data: null, fetching: false, error: null };
    case GET_DASHBOARD_ORDERS_COUNTS_REQUEST:
      return { ...state, fetchingCounts: true };
    case GET_DASHBOARD_ORDERS_COUNTS_SUCCESS:
      return { ...state, fetchingCounts: false, counts: action.payload.data?.data };
    case GET_DASHBOARD_ORDERS_COUNTS_FAILURE:
      return {
        ...state,
        fetchingCounts: false,
        error: action.error?.response?.data?.error?.text || action.error.message,
      };
    case GET_DASHBOARD_ORDERS_COUNTS_PER_PHARMACY_REQUEST:
      return { ...state, fetchingOrdersCountPerPharmacy: true };
    case GET_DASHBOARD_ORDERS_COUNTS_PER_PHARMACY_SUCCESS:
      return {
        ...state,
        fetchingOrdersCountPerPharmacy: false,
        ordersCountPerPharmacy: action.payload.data?.data,
      };
    case GET_DASHBOARD_ORDERS_COUNTS_PER_PHARMACY_FAILURE:
      return {
        ...state,
        fetchingOrdersCountPerPharmacy: false,
        error: action.error?.response?.data?.error?.text || action.error.message,
      };
    case GET_PHARMACIES_TO_ASSIGN_REQUEST:
      return { ...state, fetchingPharmacies: true };
    case GET_PHARMACIES_TO_ASSIGN_SUCCESS:
      return { ...state, fetchingPharmacies: false, pharmacies: action.payload.data?.data };
    case GET_PHARMACIES_TO_ASSIGN_FAILURE:
      return {
        ...state,
        fetchingPharmacies: false,
        errorPharmacies: action.error?.response?.data?.error?.text || action.error.message,
      };
    default:
      return state;
  }
};

export default dashboardReducer;
